import {
  GET_PAGE_BY_ID,
  GET_PAGE_BY_ID_SUCCESS,
  GET_WIDGETS,
  GET_WIDGETS_SUCCESS,
  GET_PAGE_AND_WIDGETS_BY_PAGE_ID,
  UPDATE_PAGE,
  UPDATE_PAGE_SUCCESS,
  CREATE_WIDGETS_AND_UPDATE_PAGE,
  UPDATE_WIDGETS,
  UPDATE_ONE_WIDGET,
  UPDATE_ONE_WIDGET_SUCCESS,
  DELETE_WIDGETS,
  RESET_PAGE_PROPS,
  //DICTIONARY
  SET_DICTIONARY_WIDGET_TEMP_NEW_ID,
  CLEAR_DICTIONARY,
  //COMPARISON VALUE SELECTION
  SELECT_COMPARISON_VALUE,
  REMOVE_COMPARISON_VALUE,
  CLEAR_COMPARISON_VALUES,
  //FILTER VALUE SELECTION
  SET_FILTER_VALUE,
  CLEAR_VALUE_FILTER_SELECTED,
  REMOVE_SELECTED_VALUE,
  //PAGE THUMBNAIL
  SCREENSHOT_AND_SAVE_PAGE_THUMBNAIL,
  //WIDGET DATA
  GET_WIDGET_DATA,
  GET_WIDGET_DATA_SUCCESS,
  GET_FIELD_INFOS,
  GET_FIELD_INFOS_SUCCESS,
  CLONE_DATA_FROM_WIDGET_BEING_EDITED_AND_CLEAN_IT,
  CLONE_DATA_FROM_WIDGET_TO_WIDGET_BEING_EDITED,
  CLONE_FILTER_DATA_FROM_WIDGET_BEING_EDITED_AND_CLEAN_IT,
  CLONE_FILTER_DATA_FROM_WIDGET_TO_WIDGET_BEING_EDITED,
  //pagePermission
  GET_PAGE_PERMISSION,
  GET_PAGE_PERMISSION_SUCCESS,
  CREATE_NEW_PAGE_PERMISSION,
  CREATE_NEW_PAGE_PERMISSION_SUCCESS,
  UPDATE_PAGE_PERMISSION,
  UPDATE_PAGE_PERMISSION_SUCCESS,
  DELETE_PAGE_PERMISSION,
  DELETE_PAGE_PERMISSION_SUCCESS,
  UPDATE_PAGE_IS_PUBLIC,
  UPDATE_PAGE_IS_PUBLIC_SUCCESS,
  //DUPLICATE, DELETE
  DUPLICATE_PAGE,
  DUPLICATE_CUBE_PAGE,
  DELETE_CUBE_PAGE,
  DELETE_FULL_PAGE,
  // UPLOADS
  UPLOAD_BACKGROUND_PAGE,
  UPLOAD_THUMBNAIL_PAGE,
  UPLOAD_WIDGET_IMAGE_PAGE,
  UPLOAD_WIDGET_IMAGE_PAGE_STATUS_RESET,
  UPLOAD_WIDGET_IMAGE_PAGE_STATUS_PENDING,
  UPLOAD_WIDGET_IMAGE_PAGE_STATUS_SUCCESS,
  // REQUEST STATUS
  SET_WIDGET_REQUEST_STATUS,
  //OTHER
  SET_LAST_WIDGET_SAVED,
  CHANGE_SAVING_PAGE_STATUS,
  // DRILL DOWN
  SET_DRILLDOWN_ENABLED,
} from "./constants"

export function getPageByIdAction(payload) {
  return {
    type: GET_PAGE_BY_ID,
    payload,
  }
}

export function getPageByIdSuccess(payload) {
  return {
    type: GET_PAGE_BY_ID_SUCCESS,
    payload,
  }
}

export function getWidgetsAction(payload) {
  return {
    type: GET_WIDGETS,
    payload,
  }
}

export function getWidgetsSuccess(payload) {
  return {
    type: GET_WIDGETS_SUCCESS,
    payload,
  }
}

export function getPageAndWidgetsByPageIdAction(payload) {
  return {
    type: GET_PAGE_AND_WIDGETS_BY_PAGE_ID,
    payload,
  }
}

export function updatePageAction(payload) {
  return {
    type: UPDATE_PAGE,
    payload,
  }
}

export function updatePageSuccess(payload) {
  return {
    type: UPDATE_PAGE_SUCCESS,
    payload,
  }
}

export function createWidgetsAndUpdatePageAction(payload) {
  return {
    type: CREATE_WIDGETS_AND_UPDATE_PAGE,
    payload,
  }
}

export function updateWidgetsAction(payload) {
  return {
    type: UPDATE_WIDGETS,
    payload,
  }
}

export function updateWidgetsSuccess(payload) {
  return {
    type: UPDATE_WIDGETS,
    payload,
  }
}

export function updateOneWidgetAction(payload) {
  return {
    type: UPDATE_ONE_WIDGET,
    payload,
  }
}

export function updateOneWidgetSuccess(payload) {
  return {
    type: UPDATE_ONE_WIDGET_SUCCESS,
    payload,
  }
}

export function deleteWidgetsAction(payload) {
  return {
    type: DELETE_WIDGETS,
    payload,
  }
}

//DICTIONARY
export function setDictionaryWidgetTempNewId(payload) {
  return {
    type: SET_DICTIONARY_WIDGET_TEMP_NEW_ID,
    payload,
  }
}

export function clearDictionaryAction(payload) {
  return {
    type: CLEAR_DICTIONARY,
    payload,
  }
}

//FILTER VALUE SELECTION
export function selectComparisonValueAction(payload) {
  return {
    type: SELECT_COMPARISON_VALUE,
    payload,
  }
}

export function removeComparisonValueAction(payload) {
  return {
    type: REMOVE_COMPARISON_VALUE,
    payload,
  }
}

export function clearComparisonValuesAction(payload) {
  return {
    type: CLEAR_COMPARISON_VALUES,
    payload,
  }
}

//FILTER VALUE SELECTION
export function setFilterValueAction(payload) {
  return {
    type: SET_FILTER_VALUE,
    payload,
  }
}

export function clearValueFilterSelectedAction(payload) {
  return {
    type: CLEAR_VALUE_FILTER_SELECTED,
    payload,
  }
}

export function removeSelectedValueAction(payload) {
  return {
    type: REMOVE_SELECTED_VALUE,
    payload,
  }
}

//FILTER VALUE SELECTION
export function takeScreenshotAndSaveThumbnailAction(payload) {
  return {
    type: SCREENSHOT_AND_SAVE_PAGE_THUMBNAIL,
    payload,
  }
}

//WIDGET DATA
export function getWidgetDataAction(payload) {
  return {
    type: GET_WIDGET_DATA,
    payload,
  }
}

export function getWidgetDataSuccess(payload) {
  return {
    type: GET_WIDGET_DATA_SUCCESS,
    payload,
  }
}

export function getFieldInfosAction(payload) {
  return {
    type: GET_FIELD_INFOS,
    payload,
  }
}

export function getFieldInfosSuccess(payload) {
  return {
    type: GET_FIELD_INFOS_SUCCESS,
    payload,
  }
}

export function cloneDataFromWidgetBeingEditedAndCleanItAction(payload) {
  return {
    type: CLONE_DATA_FROM_WIDGET_BEING_EDITED_AND_CLEAN_IT,
    payload,
  }
}

export function cloneDataFromWidgetToWidgetBeingEditedAction(payload) {
  return {
    type: CLONE_DATA_FROM_WIDGET_TO_WIDGET_BEING_EDITED,
    payload,
  }
}

export function cloneFilterDataFromWidgetBeingEditedAndCleanItAction(payload) {
  return {
    type: CLONE_FILTER_DATA_FROM_WIDGET_BEING_EDITED_AND_CLEAN_IT,
    payload,
  }
}

export function cloneFilterDataFromWidgetToWidgetBeingEditedAction(payload) {
  return {
    type: CLONE_FILTER_DATA_FROM_WIDGET_TO_WIDGET_BEING_EDITED,
    payload,
  }
}

//PERMISSION
export function getPagePermissionAction(payload) {
  return {
    type: GET_PAGE_PERMISSION,
    payload,
  }
}

export function getPagePermissionSuccess(payload) {
  return {
    type: GET_PAGE_PERMISSION_SUCCESS,
    payload,
  }
}

export function createNewPagePermissionAction(payload) {
  return {
    type: CREATE_NEW_PAGE_PERMISSION,
    payload,
  }
}

export function createNewPagePermissionSuccess(payload) {
  return {
    type: CREATE_NEW_PAGE_PERMISSION_SUCCESS,
    payload,
  }
}

export function updatePagePermissionAction(payload) {
  return {
    type: UPDATE_PAGE_PERMISSION,
    payload,
  }
}

export function updatePagePermissionSuccess(payload) {
  return {
    type: UPDATE_PAGE_PERMISSION_SUCCESS,
    payload,
  }
}

export function deletePagePermissionAction(payload) {
  return {
    type: DELETE_PAGE_PERMISSION,
    payload,
  }
}

export function deletePagePermissionSuccess(payload) {
  return {
    type: DELETE_PAGE_PERMISSION_SUCCESS,
    payload,
  }
}

export function updatePageIsPublicAction(payload) {
  return {
    type: UPDATE_PAGE_IS_PUBLIC,
    payload,
  }
}

export function updatePageIsPublicSuccess(payload) {
  return {
    type: UPDATE_PAGE_IS_PUBLIC_SUCCESS,
    payload,
  }
}

//CLEAR/DELETE FULL PAGE
export function deleteFullPageAction(payload) {
  return {
    type: DELETE_FULL_PAGE,
    payload,
  }
}

export function duplicatePageAction(payload) {
  return {
    type: DUPLICATE_PAGE,
    payload,
  }
}

export function duplicateCubePageAction(payload) {
  return {
    type: DUPLICATE_CUBE_PAGE,
    payload,
  }
}

export function deleteCubePageAction(payload) {
  return {
    type: DELETE_CUBE_PAGE,
    payload,
  }
}

// UPLOADS
export const uploadBackgroundImageAction = payload => ({
  type: UPLOAD_BACKGROUND_PAGE,
  payload,
})

export const uploadThumbnailImageAction = payload => ({
  type: UPLOAD_THUMBNAIL_PAGE,
  payload,
})

export const uploadWidgetImageAction = payload => ({
  type: UPLOAD_WIDGET_IMAGE_PAGE,
  payload,
})

export const uploadWidgetImageStatusActionReset = payload => ({
  type: UPLOAD_WIDGET_IMAGE_PAGE_STATUS_RESET,
  payload,
})

export const uploadWidgetImageStatusActionPending = payload => ({
  type: UPLOAD_WIDGET_IMAGE_PAGE_STATUS_PENDING,
  payload,
})

export const uploadWidgetImageStatusActionSuccess = payload => ({
  type: UPLOAD_WIDGET_IMAGE_PAGE_STATUS_SUCCESS,
  payload,
})

// REQUEST STATUS
export const setWidgetRequestStatus = payload => ({
  type: SET_WIDGET_REQUEST_STATUS,
  payload,
})

export const resetPagePropsAction = () => ({
  type: RESET_PAGE_PROPS,
})

export const setLastWidgetSavedAction = payload => ({
  type: SET_LAST_WIDGET_SAVED,
  payload,
})

//SAVING STATUS
export const changeSavingPageStatusAction = payload => ({
  type: CHANGE_SAVING_PAGE_STATUS,
  payload,
})

// DRILL DOWN
export function setDrillDownEnabledAction(payload) {
  return { type: SET_DRILLDOWN_ENABLED, payload }
}
